import { Project, ProjectForResolver } from "db/definitions";

const RECENT_PROJECTS_KEY = "recent_projects";
const RETENTION_DAYS = 7;

export interface RecentProject {
	description: string;
	group: string;
	id: string;
	name: string;
	timestamp: number;
}

export const getRecentProjects: () => RecentProject[] = () => {
	const data = localStorage.getItem(RECENT_PROJECTS_KEY);
	if (!data) return [];

	const parsed = JSON.parse(data);

	const now = Date.now();
	const validProjects = parsed.filter((proj: any) => now - proj.timestamp < RETENTION_DAYS * 24 * 60 * 60 * 1000);
	localStorage.setItem(RECENT_PROJECTS_KEY, JSON.stringify(validProjects));

	return validProjects;
};

export const updateRecentProjects = (project: Pick<Project | ProjectForResolver, "id" | "name" | "description" | "group">) => {
	let projects = getRecentProjects();
	// Remove if project already exists
	projects = projects.filter((proj: RecentProject) => proj.id !== project.id);
	// Add new project at the top
	projects.unshift({
		description: project.description,
		group: project.group,
		id: project.id,
		name: project.name,
		timestamp: Date.now(),
	});
	// Keep only the top 3
	if (projects.length > 3) projects = projects.slice(0, 3);
	// Store back in localStorage
	localStorage.setItem(RECENT_PROJECTS_KEY, JSON.stringify(projects));
	return projects;
};

export const deleteRecentProjects = (project: Project) => {
	let projects = getRecentProjects();
	// Find index of project
	const projectIndex = projects.findIndex((proj: RecentProject) => proj.id === project.id);
	// Delete Project
	projects.splice(projectIndex, 1);
	// Keep only the top 3
	if (projects.length > 3) projects = projects.slice(0, 3);
	// Store back in localStorage
	localStorage.setItem(RECENT_PROJECTS_KEY, JSON.stringify(projects));
	return projects;
};
